import React from 'react';
import { Video, Utensils, TrendingUp, Lightbulb, CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const blockIcons = [Video, Utensils, TrendingUp, Lightbulb];

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section id="funksjoner" className="py-24 bg-dark border-y border-border-dark/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="text-primary-light text-sm font-bold uppercase tracking-[0.2em]">{t.how.kicker}</span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white font-heading">
            {t.how.title}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
              {t.how.titleGrad}
            </span>
          </h2>
          <p className="mt-5 text-lg text-slate-400 leading-relaxed">{t.how.intro}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {t.how.blocks.map((feature, index) => {
            const Icon = blockIcons[index % blockIcons.length];
            return (
              <div
                key={feature.title}
                className="bg-card-dark border border-border-dark rounded-2xl p-8 hover:border-accent/25 transition-all duration-300 group"
              >
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 bg-accent/10 border border-accent/20 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-accent/15 transition-colors">
                    <Icon className="w-7 h-7 text-accent" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-xl font-bold text-white mb-3 font-heading">{feature.title}</h3>
                    <p className="text-slate-400 leading-relaxed mb-5">{feature.description}</p>
                    <ul className="space-y-2">
                      {feature.points.map((point) => (
                        <li key={point} className="flex items-center gap-2 text-sm text-slate-300">
                          <CheckCircle className="w-4 h-4 text-primary shrink-0" />
                          <span>{point}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
